import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
}

const NoneIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 20;
  const color = props.color || '#ccc';
  return <Icon name={'none'} size={size} color={color} />;
};

export default React.memo(NoneIcon);
